import React, { useState } from 'react'
import ReactTable from 'react-table'
import ReactJson from 'react-json-view'
import dayjs from 'dayjs'

import { groupBy } from '../../../common/utils'

type Props = {
  isLoading: Boolean,
  data: [],
  columns: [],
}

const timestampAccessor = (d) => dayjs(d.timestamp).format('HH:mm:s.SSS')
const typeAccessor = (d) => {
  if (d.type === 'bluetooth') {
    if (d.message.action === 'getQlocxPeripherals') return '🔄 Bluetooth-scanning' // TODO: CHECK IF WE CAN CHECK FOR NOT SUCCESSFUL

    if (d.message.successful) return '🟩 Bluetooth-öppning'

    return '🚫 Misslyckad Bluetooth-öppning'
  }

  return '✅ Verifierad öppning'
}

const dataCell = ({ value }: { value: {} }) => {
  if (value.type === 'bluetooth') {
    return (
      <div>
        {!value.message.successful && `Felmeddelande: ${value.message.reason}`}
        <ReactJson collapsed displayDataTypes={false} name={false} displayObjectSize={false} src={value.message.entries} />
      </div>
    )

    return
  }
  return `Lås: ${value.lockName}, signalstyrka: ${value.signalStrength}`
}

const defaultColumns = [
  {
    Header: 'timestamp:',
    id: 'timestamp',
    accessor: timestampAccessor,
    Cell: (d) => d.value,
  },
  {
    Header: 'Typ:',
    id: 'type',
    accessor: typeAccessor,
    Cell: ({ value }) => value,
  },
  {
    Header: 'Data:',
    id: 'data',
    accessor: (d) => d,
    Cell: dataCell,
  },
]

const TrackingTable = ({ isLoading, data, columns }: Props) => {
  const [activeDate, setActiveDate] = useState('')

  const groups = data[0] && data[0].timestamp && groupBy(data, (i) => dayjs(i.timestamp).format('YYYYMMDD'))

  return (
    <div>
      <div style={{ display: 'flex', marginBottom: 10 }}>
        {groups
          && [...groups.keys()].map((date) => (
            <div
              onClick={() => setActiveDate(date)}
              style={{ boxShadow: '2px 2px 8px 2px lightgrey', marginRight: 30, background: activeDate === date ? 'rgb(0, 110, 120)' : '#fff', color: activeDate === date ? '#fff' : '#000', cursor: 'pointer', marginTop: 6, padding: 6, borderRadius: 10 }}
              key={date}
            >
              <h3>
                {dayjs(date)
                  .format('dddd DD/MM')
                  .split('')
                  .map((s, i) => (i === 0 ? s.toUpperCase() : s))}
              </h3>
            </div>
          ))}
      </div>
      {(!groups || activeDate) && (
        <ReactTable
          data={groups ? groups.get(activeDate) : data}
          filterable
          columns={columns || defaultColumns}
          NoDataComponent={() => null}
          showPagination={true}
          showPageSizeOptions={false}
          loading={isLoading}
          loadingText="Laddar..."
          pageSize={20}
          className="-striped -highlight"
          sortable={true}
        />
      )}
    </div>
  )
}

export default TrackingTable
